var load = function load(file) {
  return new Promise(function (resolve, reject) {
    var fileReader = new window.FileReader();
    fileReader.addEventListener("load", function (evt) {
      return resolve(evt.target.result);
    }, false);
    fileReader.addEventListener("error", reject, false);
    fileReader.readAsDataURL(file);
  });
};
export default {
  load: load
};